import { AssetQueryData, AssetSource } from '@cesdk/engine'

import {
  fetchProducts,
  productQueryKeys,
} from '../../../hooks/shopwith/products/queries'

async function findProductsAssets(queryData: AssetQueryData) {
  const response = await fetchProducts({
    meta: undefined,
    queryKey: productQueryKeys.list({ search: queryData.query }),
    pageParam: queryData.page,
  })

  return {
    assets: response.data.map((d) => ({
      id: d.objectId,
      meta: {
        uri: d.featuredImage ?? d.cloudinary?.data?.secure_url,
        thumbUri: d.featuredImage ?? d.cloudinary?.data?.secure_url,
      },
    })),
    total: response.totalCount,
    currentPage: queryData.page,
    nextPage: response.hasNextPage ? queryData.page + 1 : undefined,
  }
}

const productAssetsLibrary: AssetSource = {
  id: 'products-assets',
  findAssets: findProductsAssets,
}

export { productAssetsLibrary }
